import React from 'react'

import { EChartsOption } from 'echarts'
import { BarChart, BarSeriesOption } from 'echarts/charts'
import {
  TooltipComponent,
  TooltipComponentOption,
  GridComponent,
  GridComponentOption,
  LegendComponent,
  LegendComponentOption,
  DatasetComponent,
} from 'echarts/components'
import * as echarts from 'echarts/core'
import { CanvasRenderer } from 'echarts/renderers'
import ReactECharts from 'echarts-for-react'

echarts.use([TooltipComponent, GridComponent, LegendComponent, BarChart, CanvasRenderer, DatasetComponent])

export interface VChartSeries extends Partial<BarSeriesOption> {
  name: string
  data: number[] | string[]
}

export interface VerticalBarChartProps {
  xAxisData: string[] | number[]
  series: VChartSeries[]
  className?: string
  showLegend?: boolean | 'auto'
  onBarClick?: (params: { seriesName: string; name: string }) => void
}

type ECOption =
  | EChartsOption
  | {
      // title?: TitleComponentOption
      tooltip?: TooltipComponentOption
      grid?: GridComponentOption
      legend?: LegendComponentOption
      series?: BarSeriesOption | BarSeriesOption[]
    }

export default function VerticalBarChart({ series, xAxisData, showLegend, onBarClick }: VerticalBarChartProps) {
  const processedSeries: BarSeriesOption[] = series.map((s) => ({
    type: 'bar' as const,
    barWidth: '20%',
    ...s,
  }))

  let legendVisible: boolean
  if (showLegend === 'auto') {
    legendVisible = processedSeries.length > 1
  } else {
    legendVisible = showLegend ?? false
  }

  const option: ECOption = {
    tooltip: {
      trigger: 'axis',
      axisPointer: {
        type: 'shadow',
      },
      order: 'seriesDesc',
    },
    legend: {
      show: legendVisible,
      bottom: 5,
    },
    grid: {
      left: '3%',
      right: '4%',
      top: '10%',
      bottom: legendVisible ? '20%' : '3%',
      containLabel: true,
    },
    xAxis: [
      {
        type: 'category',
        data: xAxisData,
        axisTick: {
          alignWithLabel: true,
        },
      },
    ],
    yAxis: [
      {
        type: 'value',
      },
    ],
    series: processedSeries,
  }
  const onEvents = onBarClick
    ? {
        click: (params: { seriesName: string; name: string }) => {
          onBarClick(params)
        },
      }
    : undefined
  return <ReactECharts option={option} style={{ height: '98%', width: '98%' }} onEvents={onEvents} />
}
